import { makeStyles } from '@material-ui/core/styles';

import type { CustomTheme } from 'theme';
import type { PageStylesProps } from 'pages/shared';

type SignUpPageStylesProps = PageStylesProps;

const useStyles = makeStyles((theme: CustomTheme) => ({
  container: {
    flexGrow: 1,
  },
  signUpFormContainer: ({
    firstChildTopSpacing = 0,
  }: SignUpPageStylesProps) => ({
    flexGrow: 1,
    alignItems: 'center',
    marginTop: theme.spacing(firstChildTopSpacing),
  }),
}));

export default useStyles;
